import { render, staticRenderFns } from "./ServiceResources.vue?vue&type=template&id=d1c294c4&"
import script from "./ServiceResources.vue?vue&type=script&lang=js&"
export * from "./ServiceResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports